type EmptyStateResearchIconProps = {
  size?: string | number;
};

export const EmptyStateResearchIcon = ({ size = 280 }: EmptyStateResearchIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M226.019 106.097C226.019 106.097 197.09 130.481 227.891 184.955C255.246 233.333 189.878 252.421 162.148 246.207C126.227 238.157 106.885 191.333 78.8021 205.336C50.7192 219.339 25.3614 152.166 66.3053 128.674C117.238 99.4508 85.6813 80.9774 90.851 58.7663C94.561 42.8253 141.186 19.1755 165.063 48.0315C185.154 72.3132 195.619 64.0566 205.229 61.1146C219.088 56.8712 248.313 81.4117 226.019 106.097Z"
      fill="#EEF4FF"
    />
    <path
      d="M192.017 70.3357L129.597 60.1073C125.019 59.3571 120.699 62.4602 119.949 67.0384L98.3589 198.796C97.6088 203.374 100.712 207.694 105.29 208.444L167.71 218.672C172.288 219.422 176.608 216.319 177.358 211.741L198.948 79.9835C199.699 75.4053 196.595 71.0859 192.017 70.3357Z"
      fill="#1B1D4B"
    />
    <path
      d="M189.964 74.0491L130.356 64.2816C127.304 63.7814 124.425 65.8502 123.925 68.9023L102.721 198.298C102.221 201.351 104.29 204.23 107.342 204.73L166.95 214.498C170.002 214.998 172.881 212.929 173.381 209.877L194.585 80.4809C195.085 77.4288 193.016 74.5492 189.964 74.0491Z"
      fill="#363BC4"
    />
    <g clipPath="url(#clip0_empty_research)">
      <path
        d="M154.532 137.758L140.202 135.406M143.411 145.743L138.635 144.96M160.876 128.989L141.77 125.853M169.057 138.916L170.508 130.079C171.166 126.066 171.495 124.06 170.966 122.399C170.5 120.938 169.584 119.662 168.349 118.754C166.944 117.722 164.938 117.393 160.925 116.734L145.64 114.226C141.628 113.567 139.621 113.238 137.961 113.767C136.5 114.233 135.224 115.149 134.316 116.385C133.283 117.789 132.954 119.795 132.295 123.808L128.219 148.646C127.561 152.659 127.231 154.665 127.761 156.326C128.226 157.787 129.143 159.063 130.378 159.971C131.783 161.003 133.789 161.332 137.802 161.991L144.25 163.049M169.327 167.165L166.332 162.994M169.7 157.416C168.943 162.032 164.586 165.16 159.97 164.403C155.353 163.645 152.225 159.288 152.982 154.672C153.74 150.055 158.097 146.927 162.713 147.685C167.33 148.442 170.458 152.799 169.7 157.416Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_empty_research">
        <rect width="58.0851" height="58.0851" fill="white" transform="translate(125.407 106) rotate(9.31985)" />
      </clipPath>
    </defs>
  </svg>
);
